export default function Subtract(props: any) {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="17" viewBox="0 0 16 17" fill="none" {...props}>
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M8 0.5C3.58172 0.5 0 4.08172 0 8.5C0 12.9183 3.58172 16.5 8 16.5C12.4183 16.5 16 12.9183 16 8.5C16 4.08172 12.4183 0.5 8 0.5ZM10.7504 8.82412C10.9717 8.66446 10.9717 8.33506 10.7504 8.17541L7.03396 5.49327C6.76941 5.30235 6.39987 5.49138 6.39987 5.81763L6.39987 11.1819C6.39987 11.5081 6.76941 11.6972 7.03395 11.5063L10.7504 8.82412Z"
                fill="white"
            />
        </svg>
    );
}
